import { Link } from "react-router-dom";
import { Mail, Phone } from "lucide-react";
import { COMPANY, SEDI, COURSES, LOGO_URL } from "@/lib/data";

export default function Footer() {
    const year = new Date().getFullYear();
    return (
        <footer className="bg-ink text-white" data-testid="main-footer">
            <div className="container-7m py-16 lg:py-24">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
                    <div className="md:col-span-4">
                        <Link to="/" className="inline-block">
                            <img src={LOGO_URL} alt="7MED" className="h-10 sm:h-11 w-auto object-contain" />
                        </Link>
                        <p className="mt-5 text-sm sm:text-[15px] text-white/70 max-w-xs leading-relaxed">
                            Formazione di primo soccorso e BLS-AED SRC in Svizzera. Per aziende e aspiranti conducenti.
                            Noleggio e manutenzione defibrillatori AED.
                        </p>
                        <div className="mt-6 flex flex-wrap gap-2 text-[10px] uppercase tracking-[0.18em] font-mono text-white/40">
                            <span>SRC</span><span>·</span><span>EduQua</span><span>·</span><span>USTRA</span><span>·</span><span>OLL3</span>
                        </div>
                    </div>

                    <div className="md:col-span-3">
                        <div className="text-[11px] uppercase tracking-[0.18em] font-mono text-brand mb-4">I nostri corsi</div>
                        <ul className="space-y-3 text-[15px]">
                            {COURSES.map((c) => (
                                <li key={c.slug}>
                                    <Link className="hover:text-brand block" to={c.href}>
                                        <div className="font-medium">{c.title}</div>
                                        <div className="text-xs text-white/40 mt-0.5">{c.audienceLabel}</div>
                                    </Link>
                                </li>
                            ))}
                            <li className="pt-2 border-t border-white/10 mt-2">
                                <Link className="hover:text-brand text-xs uppercase tracking-wider" to="/defibrillatori-noleggio">Defibrillatori noleggio →</Link>
                            </li>
                        </ul>
                    </div>

                    <div className="md:col-span-5">
                        <div className="text-[11px] uppercase tracking-[0.18em] font-mono text-brand mb-4">4 Sedi · Ticino</div>
                        <ul className="grid grid-cols-2 gap-x-6 gap-y-3 text-[15px]">
                            {SEDI.map((s) => (
                                <li key={s.slug}>
                                    <div className="font-bold">{s.city}</div>
                                    <div className="text-xs text-white/55">{s.address}</div>
                                    <div className="text-xs text-white/55">{s.zip}</div>
                                </li>
                            ))}
                        </ul>
                        <div className="mt-6 space-y-2 text-[15px]">
                            <a href={`tel:${COMPANY.phoneRaw}`} className="flex items-center gap-2 hover:text-brand"><Phone className="w-4 h-4" />{COMPANY.phone}</a>
                            <a href={`mailto:${COMPANY.email}`} className="flex items-center gap-2 hover:text-brand"><Mail className="w-4 h-4" />{COMPANY.email}</a>
                        </div>
                    </div>
                </div>

                <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row md:items-center md:justify-between gap-4 text-xs text-white/50 font-mono">
                    <div>© {year} 7MED GROUP — Tutti i diritti riservati</div>
                    <div className="flex flex-wrap gap-x-6 gap-y-2">
                        <Link to="/blog" className="hover:text-brand">Blog</Link>
                        <Link to="/privacy-policy" className="hover:text-brand">Privacy</Link>
                        <Link to="/termini-e-condizioni" className="hover:text-brand">Termini</Link>
                        <Link to="/impressum" className="hover:text-brand">Impressum</Link>
                        <Link to="/admin/login" className="hover:text-brand opacity-50">Admin</Link>
                    </div>
                </div>
            </div>
        </footer>
    );
}
